import React, { useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import { UpdateDesignationApi, DeleteDesignationApi } from "./designationAction";
import { setHeading } from "../../../accounts/account.actions";
import { baseURL, headers } from "../../../../../global/api";
import { connect } from "react-redux";
// import _ from "lodash";
import MaterialTable from 'material-table';


const DesignationList = (props) => {
    const tableRef = useRef();
    function updateTableQuery() {
        tableRef.current.onQueryChange()
    };
    
    useEffect(() => {
        props.setHeading("Designation List")
    }, []);

    return (
        <>
            <Container fluid>
                <MaterialTable
                    title="Designation List"
                    tableRef={tableRef}
                    columns={[
                        { title: 'Designation ID', field: 'sequenceNumber', editable: 'never' },
                        { title: 'Division Name', field: 'divisionDetails.name', editable: 'never' },
                        { title: 'Department Name', field: 'departmentDetails.department', editable: 'never' },
                        { title: 'Designation Name', field: 'designation' },
                        { title: 'Designation Description', field: 'description' },
                    ]}
                    data={(query) =>
                        new Promise((resolve, reject) => {
                            let url = `${baseURL}/designation?`;
                            url += "limit=" + query.pageSize;
                            url += "&page=" + query.page;
                            url += "&search=" + query.search;
                            fetch(url, {
                                method: "GET",
                                headers: headers,
                            }).then((response) => response.json()).then((result) => {
                                resolve({
                                    data: result.data,
                                    page: result.page,
                                    totalCount: result.total_results,
                                });
                            });
                        })
                    }
                    options={{
                        actionsColumnIndex: -1,
                        filtering: false,
                        exportButton: true,
                        exportAllData: true,
                        sorting: true,
                        paging: true,
                        pageSize: 50,
                        emptyRowsWhenPaging: false,
                        pageSizeOptions: [50, 100, 150, 200, 500],
                        headerStyle: {
                            position: 'sticky', top: 0,
                            color: '#00BBBB',
                            fontWeight: '550',
                            onRowAdd: 'none',
                        },

                    }}
                    editable={{
                        onRowUpdate: (newData, oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    props.UpdateDesignationApi(newData, oldData, updateTableQuery)
                                }, 600);
                            }),
                        onRowDelete: (oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    props.DeleteDesignationApi(oldData._id, updateTableQuery);
                                }, 600);
                            }),
                    }}
                    actions={[
                        {
                            icon: 'refresh',
                            tooltip: 'Refresh Data',
                            isFreeAction: true,
                            onClick: () => tableRef.current && tableRef.current.onQueryChange(),
                        },
                    ]}
                />
            </Container>
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        DeleteDesignationApi: (designation_id, updateTableQuery) => dispatch(DeleteDesignationApi(designation_id, updateTableQuery)),
        UpdateDesignationApi: (newData, oldData, updateTableQuery) => dispatch(UpdateDesignationApi(newData, oldData, updateTableQuery)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(DesignationList);